import { useContext, useEffect, useState} from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import { ReactComponent as PasswordIcon } from "../../../icons/password.svg";
import { ReactComponent as ViewIcon } from "../../../icons/view.svg";
import { ReactComponent as NotViewIcon } from "../../../icons/not-view.svg";
import { ApiError } from "../../../services/ApiError";
import "./setPassword.css";

function SetPassword(){
    const [searchParams] = useSearchParams();
    const [password, setPassword] = useState("");
    const [passwordDouble, setPasswordDouble] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loadingSave, setLoadingSave] = useState(false);
    const [viewPassword, setViewPassword] = useState(false);
    const [viewPasswordDouble, setViewPasswordDouble] = useState(false);
    const [userId, setUserId] = useState(searchParams.get("userId") || "");
    const [token, setToken] = useState(searchParams.get("token") || "");
    const { infrastructureService } = useContext(ServiceContext);
    const [isOpen , setIsOpen] = useState(false);
    const navigate = useNavigate();  
    
    function onCancelClick() {
      navigate("/");
    }
    
    function validatePasswords(password, passwordDouble) {
        if (password !== passwordDouble) {
            setErrorMessage("The password and confirmation password do not match.");
            return false;
        }
        return true;
    }
  
    const onSetPasswordClick = async () => {
      try{
        setLoadingSave(true);
        if (!validatePasswords(password, passwordDouble)) return;
        let body = {
                userId: userId,
                token: token.replace(/ /g, "+"),
                newPassword: password
            };
        await infrastructureService.post("User/resetPassword", body);
        setIsOpen(true);        
      }catch (err) {
        if (err instanceof ApiError) {
            if (err.errors) {
                setErrorMessage(Object.values(err.errors).flat().join("\n"));
            } else {
                setErrorMessage(err.message);
            }
        } else {
            setErrorMessage(err.message || "Unexpected error");
        }
      }
      finally{
        setLoadingSave(false);
      } 
    };

    useEffect(() => {
        const newUserId = searchParams.get("userId") || "";
        const newToken = searchParams.get("token")  || "";
        setUserId(newUserId);
        setToken(newToken);
    }, [searchParams]);

    return (
    <div className="login"> 
       {!isOpen  && (<div className="container">
        <div className="card">
          <div className="text">Set a New Password</div>
        </div>
        <div className="inputs">
          <div className="input">
            <PasswordIcon/>
            <input className="pas" type={viewPassword ? "text" : "password"} placeholder="Password" onChange={(e) => setPassword(e.target.value)} value={password}/>
            <span onClick={() => setViewPassword(!viewPassword)} style={{ cursor: "pointer" }}>
              {viewPassword ? (<ViewIcon/>) : (<NotViewIcon/>)}
            </span>
          </div>
          <div className="input">
            <PasswordIcon/>
            <input className="pas" type={viewPasswordDouble ? "text" : "password"} placeholder="Confirm Password" onChange={(e) => setPasswordDouble(e.target.value)} value={passwordDouble}/>
            <span onClick={() => setViewPasswordDouble(!viewPasswordDouble)} style={{ cursor: "pointer" }}>
              {viewPasswordDouble ? (<ViewIcon/>) : (<NotViewIcon/>)}
            </span>
          </div>
          {errorMessage && (
            <div className="error input">
              <span style={{paddingLeft: "10px"}}>{errorMessage}</span>
            </div>
           )}
          <div className="submit-container">
            <div className="cancel" onClick={onCancelClick}>Cancel</div>
            {!loadingSave && (<div className="submit" type="submit" onClick={() => onSetPasswordClick()}>Submit</div>)}
            {loadingSave && (<div className="submit">Loading...</div>)}
          </div>
        </div>
      </div>)}
      {isOpen  && (
          <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor:"white",borderRadius:"8px",width:"auto",maxWidth:"550px",boxShadow:"0 5px 15px rgba(0,0,0,0.3)"}}>
              <div style={{background:"rgb(236, 236, 236)", padding:"10px"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px" }}>
                   Success!  
                  </h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"0px 10px", textAlign: "start"}}>
                <p>Your new password has been set and you can log in.</p>
                <div style={{display:"flex",justifyContent:"center",alignItems:"center",padding:"10px", margin:"0px"}}>
                  <div style={{height:"30px",borderRadius:"8px",fontSize:"16px",width:"100px",textAlign:"center",display:"flex",justifyContent:"center",alignItems:"center"}}
                       onClick={() => {setIsOpen(false);navigate("/");}} className="submit">Ok</div>
                </div>
              </div>
            </div>
         </div>
      )}
    </div>
  )
}

export default SetPassword;